'use strict';

/**
 * Change wishlist icon and show message
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 * @param {string} action - what type of action add/remove
 */
function displayMessageAndChangeIcon(data, icon, action) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
        if (action === 'add') {
            icon.find('.heart-remove').removeClass('d-none').addClass('d-block');
            icon.find('.heart-add').removeClass('d-block').addClass('d-none');
        } else {
            icon.find('.heart-add').removeClass('d-none').addClass('d-block');
            icon.find('.heart-remove').removeClass('d-block').addClass('d-none');
        }
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
}

module.exports = {
    addRemoveProductInWishlist: function () {
        $('body').on('click', '.wishlist-heart', function (e) {
            e.preventDefault();
            var button = $(this);
            var $heartIcon = $(this).find('.js-heart:not(.d-none)');
            var url = $heartIcon.data('actionUrl');
            var method = $heartIcon.data('method');
            var pid = $(this).closest('.product').data('pid') || $(this).closest('.product-detail').data('pid');
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: method,
                dataType: 'json',
                data: {
                    pid: pid
                },
                success: function (data) {
                    displayMessageAndChangeIcon(data, button, method === 'get' ? 'remove' : 'add');

                    if ($('.page').data('action') === 'Wishlist-Show') {
                        button.closest('.js-wishlist-tile').remove();
                    }

                    if ($('.js-wishlist-tile').length === 0) {
                        $('.js-wishlist-empty').removeClass('d-none');
                    }
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err.responseJSON || err, button);
                }
            });
        });
    }
};
